import { parsePricing } from "@src/shared/parsePricing"

interface Currency {
  decimals: number
  display_name: string
  network: string
  symbol: string
  token_kind: null | string
  tx_explorer_url: string
}

export function getExplorerUrl(list: any[], currencies: Currency[]) {
  return list.map((item) => {
    const currency = currencies.find(
      (i) => i.network === item.network && i.symbol === item.symbol,
    )

    return {
      ...item,
      tx_explorer_url: currency?.tx_explorer_url,
    }
  })
}
